// Codes belonging to iso countries codes
export const countryCodes = [
  'eu',
  'ca',
  'da',
  'du',
  'en',
  'et',
  'fa',
  'fi',
  'de',
  'el',
  'he',
  'hu',
  'it',
  'no',
  'pt',
  'es',
  'sv',
  'vi',
];
